import axios from 'axios';
import { acceptDeclineInviteAction } from './AcceptDeclineInviteSlice';

const acceptDeclineInvite = (token, inviteId, action) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/family/invite/${inviteId}`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(url, { action }, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(acceptDeclineInviteAction.acceptDeclineInviteSuccess(result.data));
    } catch (e) {
      dispatch(acceptDeclineInviteAction.acceptDeclineInviteFailure(e.response?.data ?? e.message));
    }
  };
};

export default acceptDeclineInvite;